export const SAVE_RESULT_SUCCESS_DURATION_MS = 3000;
export const SAVE_RESULT_SUCCESS_KEY = 'jeecg-save-result-success';

let lastSuccessAt = 0;

export function resetSaveResultToastState() {
  lastSuccessAt = 0;
}

export function shouldShowSuccessToast(now = Date.now()): boolean {
  return lastSuccessAt === 0 || now - lastSuccessAt >= SAVE_RESULT_SUCCESS_DURATION_MS;
}

export function markSuccessToastShown(now = Date.now()) {
  lastSuccessAt = now;
}
